import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpHeaders, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

export function AuthInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {

    const authToken = inject(AuthService).token;

    if (authToken) {
        request = request.clone({
            headers: new HttpHeaders({
                Authorization: authToken
            })
        });
    }

    return next(request).pipe(catchError((err) => handleError(err)));
  }

function handleError(err: HttpErrorResponse): Observable<any> {
    const detail = err.error?.message;
    const contactAdminMessage = "Please try again or contact your administrator.";
    this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `${detail || 'There was an error performing this task.'}\n${contactAdminMessage}`
    });
    return of(err.message);
}